import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBritishColumbia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_386)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12H0Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.86955 11.344L8.21353 12H8.86955V11.344Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1305 11.344V12H15.7864L15.1305 11.344Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.346219 9.1305C0.120516 10.05 0 11.0109 0 12H3.78642L6.65592 9.1305H0.346219Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.344 9.1305L20.2135 12H24C24 11.0109 23.8794 10.05 23.6538 9.1305H17.344Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.6061 9.1305H15.1305L18 12H19.4757L16.6061 9.1305Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.86955 10.6061V9.1305H8.86945L5.99995 12H7.47567L8.86955 10.6061Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.62134 1.83478C5.12672 2.14584 4.65642 2.49188 4.21387 2.86955H6.65606L5.62134 1.83478Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.7861 2.86955C19.3436 2.49183 18.8733 2.1458 18.3788 1.83478L17.344 2.86955H19.7861Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5652 7.5652H23.1535C22.6998 6.42525 22.0763 5.37159 21.3144 4.43475H13.5653H13.5652V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V4.4347V4.43475H2.68556C1.9237 5.37159 1.30017 6.42525 0.846516 7.5652H10.4347H10.4348V12H13.5652V7.56525V7.5652Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.86955 2.86955V2.8695L7.0605 1.06045C6.72605 1.21172 6.40008 1.37836 6.08288 1.5585L7.39392 2.86955H8.86955Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1305 2.86955L16.9396 1.0605C16.5954 0.904921 16.2426 0.765421 15.8821 0.642187L15.1305 1.39392V2.86955Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12H24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.9998 13.5305C20.9999 13.5305 20.9999 12.6161 19.9998 12.6161C18.9998 12.6161 18.9998 13.5305 17.9999 13.5305C17 13.5305 16.9999 12.6161 16 12.6161C15 12.6161 15 13.5305 14 13.5305C12.9999 13.5305 12.9999 12.6161 11.9998 12.6161C10.9998 12.6161 10.9998 13.5305 9.99989 13.5305C9.00004 13.5305 9.00004 12.6161 8.00006 12.6161C6.99998 12.6161 6.99998 13.5305 5.9999 13.5305C4.99983 13.5305 4.99983 12.6161 3.99975 12.6161C2.99991 12.6161 2.99991 13.5305 1.99992 13.5305C1.00533 13.5305 0.999563 12.6262 0.0156097 12.6165C0.0433129 13.1655 0.108844 13.7043 0.207938 14.2313C1.005 14.3484 1.0748 15.1305 1.99997 15.1305C2.99995 15.1305 2.99995 14.2162 3.9998 14.2162C4.99987 14.2162 4.99987 15.1305 5.99995 15.1305C7.00003 15.1305 7.00003 14.2162 8.00011 14.2162C9.00009 14.2162 9.00009 15.1305 9.99994 15.1305C10.9999 15.1305 10.9999 14.2162 11.9999 14.2162C12.9999 14.2162 12.9999 15.1305 14 15.1305C15.0001 15.1305 15.0001 14.2162 16 14.2162C17 14.2162 17 15.1305 17.9999 15.1305C18.9999 15.1305 18.9999 14.2162 19.9999 14.2162C20.9999 14.2162 20.9999 15.1305 21.9999 15.1305C22.9251 15.1305 22.9949 14.3485 23.7921 14.2313C23.8912 13.7043 23.9566 13.1655 23.9845 12.6166C23.0003 12.6263 22.9945 13.5305 21.9998 13.5305Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.9998 15.7466C18.9998 15.7466 18.9998 16.6609 17.9999 16.6609C17 16.6609 16.9999 15.7466 16 15.7466C15 15.7466 15 16.6609 14 16.6609C12.9999 16.6609 12.9999 15.7466 11.9998 15.7466C10.9998 15.7466 10.9998 16.6609 9.99989 16.6609C9.00004 16.6609 9.00005 15.7466 8.00006 15.7466C6.99998 15.7466 6.99998 16.6609 5.9999 16.6609C4.99983 16.6609 4.99983 15.7466 3.99975 15.7466C2.9999 15.7466 2.9999 16.6609 1.99992 16.6609C1.2854 16.6609 1.08131 16.1942 0.658264 15.9276C0.939889 16.7413 1.30626 17.5154 1.7475 18.2389C1.82423 18.2531 1.90776 18.2609 1.99992 18.2609C2.9999 18.2609 2.9999 17.3467 3.99975 17.3467C4.99983 17.3467 4.99983 18.2609 5.9999 18.2609C6.99998 18.2609 6.99998 17.3467 8.00006 17.3467C9.00005 17.3467 9.00004 18.2609 9.99989 18.2609C10.9999 18.2609 10.9999 17.3467 11.9998 17.3467C12.9999 17.3467 12.9999 18.2609 14 18.2609C15 18.2609 15 17.3467 16 17.3467C17 17.3467 17 18.2609 17.9999 18.2609C18.9998 18.2609 18.9999 17.3467 19.9998 17.3467C20.9999 17.3467 20.9999 18.2609 21.9998 18.2609C22.092 18.2609 22.1756 18.2531 22.2524 18.2389C22.6936 17.5154 23.06 16.7413 23.3417 15.9277C22.9186 16.1941 22.7145 16.6609 21.9998 16.6609C20.9999 16.6609 20.9999 15.7466 19.9998 15.7466Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9935 11.623C23.9946 11.6563 23.9957 11.6896 23.9965 11.7231C23.9957 11.6897 23.9945 11.6563 23.9935 11.623Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.00351715 11.7231C0.00431403 11.6896 0.00543903 11.6563 0.00647028 11.6229C0.0054859 11.6563 0.00426715 11.6897 0.00351715 11.7231Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 11.9074 0.00140625 11.8152 0.00351563 11.7231C0.00135938 11.8152 0 11.9074 0 12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 12.2186 0.0061875 12.4358 0.0178594 12.6514C0.999563 12.6624 1.00608 13.5652 1.99997 13.5652C2.99995 13.5652 2.99995 12.651 3.9998 12.651C4.99988 12.651 4.99988 13.5652 5.99995 13.5652C7.00003 13.5652 7.00003 12.651 8.00011 12.651C9.00009 12.651 9.00009 13.5652 9.99994 13.5652C10.9999 13.5652 10.9999 12.651 11.9999 12.651C12.9999 12.651 12.9999 13.5652 14 13.5652C15.0001 13.5652 15.0001 12.651 16 12.651C17 12.651 17 13.5652 18 13.5652C18.9999 13.5652 18.9999 12.651 19.9999 12.651C21 12.651 21 13.5652 21.9999 13.5652C22.9939 13.5652 23.0004 12.6624 23.9823 12.6514C23.9938 12.4357 24 12.2186 24 12H0Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9965 11.7231C23.9986 11.8151 24 11.9074 24 12C24 11.9074 23.9986 11.8152 23.9965 11.7231Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.9998 18.877C18.9998 18.877 18.9998 19.7913 17.9999 19.7913C17 19.7913 16.9999 18.877 16 18.877C15 18.877 15 19.7913 14 19.7913C12.9999 19.7913 12.9999 18.877 11.9998 18.877C10.9998 18.877 10.9998 19.7913 9.99989 19.7913C9.00005 19.7913 9.00005 18.877 8.00006 18.877C6.99998 18.877 6.99998 19.7913 5.9999 19.7913C4.99983 19.7913 4.99983 18.877 3.99975 18.877C3.30909 18.877 3.09539 19.3131 2.69976 19.583C3.74925 20.8686 5.06034 21.9319 6.5512 22.6932L12 22.4187L17.4487 22.6932C18.9396 21.9318 20.2507 20.8686 21.3001 19.583C20.9043 19.3132 20.6906 18.877 19.9998 18.877Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.6555 19.1632L15.0051 19.8614L14.5426 16.1739L12 18.8859L9.45751 16.1739L8.99485 19.8613L5.34464 19.1631L7.13475 22.4187L6.55013 22.6936C8.1855 23.5289 10.0377 24 12 24C13.9623 24 15.8145 23.5289 17.4499 22.6937L16.8655 22.4188L18.6555 19.1632Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_386",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBritishColumbia;
